import {observer} from 'mobx-react-lite';
import type {ComponentType} from 'react';
import type {PressableProps, TextProps} from 'react-native';
import {Pressable, Text} from 'react-native';

import {variance} from '../styling';

export type ButtonViewProps = {
  Icon?: ComponentType;
  label: string;
} & PressableProps;

export default observer(function ButtonView(props: ButtonViewProps) {
  const {Icon, label, ...rest} = props;
  return (
    <Root {...rest}>
      {Icon && <Icon />}
      <ButtonText>{label}</ButtonText>
    </Root>
  );
});

const Root = variance(Pressable)(
  theme => ({
    root: {
      flexDirection: 'row',
      flexWrap: 'nowrap',
      borderWidth: 1,
      borderRadius: 12,
      borderColor: theme.palette.textPrimary,
      paddingVertical: 8,
      paddingRight: PADDING_HORIZONTAL,
      paddingLeft: PADDING_HORIZONTAL / 2,
    },
  }),
  (): PressableProps => ({
    role: 'button',
  }),
);

const ButtonText = variance(Text)(
  theme => ({
    root: {
      ...theme.text('base'),
      color: theme.palette.textPrimary,
      fontSize: 16,
      lineHeight: 22,
      marginLeft: PADDING_HORIZONTAL / 2,
    },
  }),
  (): TextProps => ({
    numberOfLines: 1,
    ellipsizeMode: 'middle',
  }),
);

const PADDING_HORIZONTAL = 32;
